module.exports = __webpack_public_path__ + "static/media/faviconNaReal.7ef478ea.ico";